module.exports = __webpack_public_path__ + "img/plb9.9462285a.png";